import { useState } from 'react'
import { ShieldCheck, Heart } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface AgeVerificationProps {
  open: boolean
  onVerified: () => void
}

export function AgeVerification_M10_12({ open, onVerified }: AgeVerificationProps) {
  const [confirmed, setConfirmed] = useState(false)

  if (!open) return null

  function handleConfirm_M10_12_1() {
    if (confirmed) {
      onVerified()
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 backdrop-blur-sm">
      {/* Ambient glow */}
      <div className="absolute top-[30%] left-[40%] h-[300px] w-[300px] rounded-full bg-primary/6 blur-[100px]" />

      <div className="relative z-10 w-full max-w-sm px-6 animate-fade-in">
        <div className="glass-strong rounded-2xl p-8 shadow-glass text-center">
          {/* Icon */}
          <div className="inline-flex items-center justify-center h-16 w-16 rounded-2xl bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/20 mb-6">
            <ShieldCheck className="h-7 w-7 text-primary" />
          </div>

          <h2 className="font-display text-2xl font-semibold text-gradient mb-2">
            Age Verification
          </h2>
          <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
            This application contains adult content. You must be at least 18 years old to continue.
          </p>

          {/* Checkbox */}
          <label className="flex items-start gap-3 cursor-pointer text-left mb-6 group">
            <input
              type="checkbox"
              checked={confirmed}
              onChange={(e) => setConfirmed(e.target.checked)}
              className="sr-only peer"
            />
            <div
              className={cn(
                'mt-0.5 h-5 w-5 rounded-md border-2 flex items-center justify-center shrink-0 transition-all duration-200',
                confirmed
                  ? 'border-primary bg-primary'
                  : 'border-border group-hover:border-primary/50 peer-focus-visible:ring-2 peer-focus-visible:ring-primary/50 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-background'
              )}
              aria-hidden="true"
            >
              {confirmed && <Heart className="h-3 w-3 text-white" />}
            </div>
            <span className="text-sm text-muted-foreground leading-relaxed">
              I confirm that I am at least 18 years of age and consent to viewing adult content.
            </span>
          </label>

          <Button
            onClick={handleConfirm_M10_12_1}
            disabled={!confirmed}
            className="w-full h-11 bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70 shadow-glow-sm transition-all duration-300 disabled:opacity-30 disabled:shadow-none"
          >
            Enter
          </Button>
        </div>
      </div>
    </div>
  )
}
